import { useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import Grid from "@material-ui/core/Grid";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";

import { TabLayout } from "../../common/TabLayout";
import { SplitedTabLayout } from "../../common/SplitedTabLayout";
import { useAuthenticationContext } from "../../context/UserContext";
import { DashboardTab } from "./tabs/dashboard/Dashboard";
import { MyTeamTab } from "./tabs/my_team/MyTeam";
import { ActivityTab } from "./tabs/activity/Activity";
import { BusinessOwnerAccountScreen } from "../business_owner_account_screen/BusinessOwnerAccountScreen";
import { HomeScreen } from "../home/HomeScreen";

import PurchaseReportTab from "./tabs/purchase_report/PurchaseReport";

import WithdrawRequestTab from "./tabs/withdraw_request/WithdrawRequest";


const useStyles = makeStyles((theme) => ({
  topRoot: {
    backgroundColor: theme.palette.background.default,
    minHeight: "100%",
    overflow: "hidden",
    width: "100%",
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  businessName: {
    color: "#000000",
    fontSize: 16,
    fontWeight: 700,
  },
  businessNameOnPopup: {
    color: "#000000",
    fontSize: 16,
    fontWeight: 700,
    flexGrow: 1,
  },
  logo: {
    widht: 43,
    height: 30,
    marginRight: 10,
  },
  businessLogo: {
    width: 30,
    height: 28,
    marginRight: 5,
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: 40,
    marginRight: 5,
  },
  root: {
    backgroundColor: theme.palette.background.default,
    display: "flex",
    height: "100%",
    overflow: "hidden",
    width: "100%",
    paddingTop: 80,
  },
  appBar: {
    backgroundColor: theme.palette.background.default,
  },
  tab: {
    textTransform: "none",
  },
  menuButton: {
    textTransform: "none",
  },
  businessButton: {
    textTransform: "none",
    border: "1px solid #B9B9C1",
    borderRadius: 6,
  },
  selected: {
    color: theme.palette.grey[400],
    fontWeight: 400,
    fontSize: 12,
    marginLeft: 50,
    textTransform: "uppercase",
  },
}));

function a11yProps(index: any) {
  return {
    id: `wrapped-tab-${index}`,
    "aria-controls": `wrapped-tabpanel-${index}`,
  };
}

export const BusinessOwnerDashboardScreen = (props: any) => {
  const classes = useStyles();
  const history = useHistory();
  const { formatMessage } = useIntl();
  const [user] = useAuthenticationContext();
  const userAvatar = user.avatar();
  const businesses = user.businesses.map((business) => ({
    id: business.id,
    name: business.company_name,
    logo: business.company_logo,
  }));
  const search = useLocation().search;
  const business = +new URLSearchParams(search).get("business");
  const [currentBusiness, setCurrentBusiness] = useState(
    business > 0 ? business : businesses[0].id
  );
  const userName = user.fullName();
  const [activeTab, setActiveTab] = useState(0);
  const [
    activeBusinessMenu,
    setActiveBusinessMenu,
  ] = useState<null | HTMLElement>(null);

  const changeTab = (_: React.ChangeEvent<{}>, tab: number) => {
    setActiveTab(tab);
  };

  const userButtonClick = (_: React.MouseEvent<HTMLButtonElement>) =>
    history.push(BusinessOwnerAccountScreen.routeName);

  const businessMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setActiveBusinessMenu(event.currentTarget);
  };

  const businessMenuClose = (business: null | number) => {
    if (Boolean(business) && business !== currentBusiness) {
      setCurrentBusiness(business);
    }
    setActiveBusinessMenu(null);
  };

  return (
    <>
      <div className={classes.topRoot}>
        <Grid container>
          <Grid item xs={12} sm={12} lg={12}>
            <AppBar className={classes.appBar} position="fixed" elevation={5}>
              <Toolbar variant="dense">
                <Link to={HomeScreen.routeName}>
                  <img
                    className={classes.logo}
                    alt="logo"
                    src={process.env.PUBLIC_URL + "/logo_blue.png"}
                  />
                </Link>
                <Button
                  className={classes.businessButton}
                  aria-controls="business-menu"
                  aria-haspopup="true"
                  onClick={businessMenuClick}
                >
                  <img
                    className={classes.businessLogo}
                    alt="logo"
                    src={
                      businesses.filter(
                        (business) => business.id === currentBusiness
                      )[0].logo
                    }
                  />
                  <Typography className={classes.businessName}>
                    {
                      businesses.filter(
                        (business) => business.id === currentBusiness
                      )[0].name
                    }
                  </Typography>
                  <ArrowDropDownIcon />
                </Button>
                <Menu
                  id="business-menu"
                  getContentAnchorEl={null}
                  anchorEl={activeBusinessMenu}
                  keepMounted
                  open={Boolean(activeBusinessMenu)}
                  onClose={() => businessMenuClose(null)}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  {businesses.map((business) => (
                    <MenuItem onClick={(_) => businessMenuClose(business.id)}>
                      <img
                        className={classes.businessLogo}
                        alt="logo"
                        src={business.logo}
                      />
                      <Typography className={classes.businessNameOnPopup}>
                        {business.name}
                      </Typography>
                      {business.id === currentBusiness && (
                        <Typography className={classes.selected}>
                          <FormattedMessage id="sharedScreen.selected" />
                        </Typography>
                      )}
                    </MenuItem>
                  ))}
                </Menu>
                <Typography className={classes.title} />
                <Button
                  className={classes.menuButton}
                  onClick={userButtonClick}
                >
                  <img
                    className={classes.avatar}
                    alt="user-avatar"
                    src={userAvatar}
                  />
                  {userName}
                  <ArrowDropDownIcon />
                </Button>
              </Toolbar>
              <Tabs
                value={activeTab}
                onChange={changeTab}
                indicatorColor="primary"
                textColor="primary"
                aria-label="full width tabs example"
              >
                <Tab
                  className={classes.tab}
                  label={formatMessage({ id: "sharedScreen.dashboard" })}
                  {...a11yProps(0)}
                />
                <Tab
                  className={classes.tab}
                  label={formatMessage({ id: "sharedScreen.myTeam" })}
                  {...a11yProps(1)}
                />
                <Tab
                  className={classes.tab}
                  label={formatMessage({ id: "sharedScreen.activity" })}
                  {...a11yProps(2)}
                />
                <Tab
                  className={classes.tab}
                  label={formatMessage({ id: "sharedScreen.withdrawRequest" })}
                  {...a11yProps(3)}
                />
              </Tabs>
            </AppBar>
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <div className={classes.root}>
              <Grid container>
                <Grid item xs={12} sm={12} lg={12}>
                  <TabLayout value={activeTab} index={0}>
                    <DashboardTab business={currentBusiness} />
                  </TabLayout>
                  <SplitedTabLayout value={activeTab} index={1}>
                    <MyTeamTab business={currentBusiness} />
                  </SplitedTabLayout>
                  <TabLayout value={activeTab} index={2}>
                    <ActivityTab business={currentBusiness} />
                  </TabLayout>
                  <TabLayout value={activeTab} index={3}>
                    <WithdrawRequestTab business={currentBusiness}  />
                  </TabLayout>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

BusinessOwnerDashboardScreen.routeName = "/business-owner-dashboard";
